import { Alert, Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../store/JSTool';
import { getImgPath } from '../store/JSTool';
import $ from 'jquery';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../store/SettingSlice';


export default function NavView(props) {

    let showContent = false;
    let showUrl = false;

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);

    React.useEffect(() => {
        if (!props.navId || !props.pageId) {
            console.error('NavView: navId or pageId is null.');
        }
        settingObj.navForceBlack = false;


        const path = window.location.pathname;
        if (path == '/') {
            dispatch(settingActions.setNavIndex(0));

        } else if (path == '/newsList') {
            dispatch(settingActions.setNavIndex(2));

        } else if (path == '/about') {
            dispatch(settingActions.setNavIndex(3));

        } else if (path == '/recruit') {
            dispatch(settingActions.setNavIndex(4));

        } else if (path == '/contact') {
            dispatch(settingActions.setNavIndex(5));
        }
        dispatch(settingActions.setLanguage(JSTool.getLang()));
    }, []);

    let timer0;
    function onNavOver() {
        clearTimeout(timer0);
        if (props.pageId && props.navId) {
            JSTool.setNavColor(props.navId, true);
        }
    }

    function onNavLeave() {
        if (props.pageId && props.navId) {
            timer0 = setTimeout(function () {
                JSTool.checkNavColor(props.pageId, props.navId, props.pageFlag);
            }, 200);
        }
    }

    let timer1;
    function showWorks() {
        clearTimeout(timer1);
        if (!showContent) {
            showContent = true;
            $("#" + props.navId + '1_line').animate({ height: 20 }, 200);
            $("#" + props.navId + '1_content').animate({ height: 90 }, 200);
        }
    }

    function hideWorks() {
        if (showContent) {
            timer1 = setTimeout(function () {
                showContent = false;
                if (!showContent) {
                    hideSFDUrl();
                    $("#" + props.navId + '1_line').animate({ height: 0 }, 200);
                    $("#" + props.navId + '1_content').animate({ height: 0 }, 200);
                }
            }, 200);
        }
    }

    let timer2;
    function showSFDUrl() {
        clearTimeout(timer0);
        clearTimeout(timer1);
        clearTimeout(timer2);
        if (!showUrl) {
            showUrl = true;
            $("#" + props.navId + 'url_content').animate({ height: 70 }, 200);
        }
    }

    function hideSFDUrl() {
        if (showUrl) {
            timer2 = setTimeout(function () {
                showUrl = false;
                $("#" + props.navId + 'url_content').animate({ height: 0 }, 180);
            }, 200);
        }
    }

    function logoTap(){
        navigate('/');
    }

    return (
        <Stack
            id={props.navId && props.navId}
            sx={{
                position: 'absolute',
                width: 1,
                zIndex: 100,
                bgcolor: (settingObj.navForceBlack && '#000000dd')
            }}>
            <Stack sx={{
                display: 'flex',
                flexDirection: 'row',
            }}>

                <Stack
                    onMouseOver={onNavOver}
                    onMouseLeave={onNavLeave}
                    sx={{
                        width: 1,
                        flexDirection: 'row',
                        mr: 6,
                    }}>
                    <Box 
                    onClick={logoTap}
                    component={'img'}
                        src={getImgPath('logo_white.png')}
                        sx={{
                            height: '40px',
                            ml: 5,
                            mt: 2.5,
                            cursor: 'pointer',
                        }} />

                    <Box sx={{ flex: 1 }} />

                    {/* 导航 */}
                    <Stack>
                        <Stack sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifySelf: 'flex-end',
                            justifyContent: 'flex-end',
                            minWidth: '800px'
                        }}>
                            {/* <NavItem index={0} title={settingData.langDic['lang0']} /> */}
                            <NavItem index={1} title={settingData.langDic['lang1']} showWorks={showWorks} hideWorks={hideWorks} navId={props.navId} />
                            <NavItem index={2} title={settingData.langDic['lang2']} />
                            <NavItem index={3} title={settingData.langDic['lang3']} />
                            <NavItem index={4} title={settingData.langDic['lang4']} />
                            <NavItem index={5} title={settingData.langDic['lang5']} />
                        </Stack>

                        <Stack
                            onMouseOver={showWorks}
                            onMouseLeave={hideWorks}>
                            {/* 下拉1 */}
                            <NavContentView
                                showSFDUrl={showSFDUrl}
                                hideSFDUrl={hideSFDUrl}
                                navId={props.navId} />

                            {/* 下拉2 */}
                            <NavContentUrl navId={props.navId} showSFDUrl={showSFDUrl} hideSFDUrl={hideSFDUrl} />

                        </Stack>

                    </Stack>
                </Stack>

                {/* 语言 */}
                <LanguageView />

            </Stack>

        </Stack>
    );
}

// 导航Item
function NavItem(props) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const settingData = useSelector(state => state.settingData);

    function itemClick() {
        const index = props.index;
        if (1 != index) {
            settingObj.navForceBlack = true;
            dispatch(settingActions.setNavIndex(props.index));
        }

        if (0 == index) {
            navigate('/');

        } else if (2 == index) {
            navigate('/newsList');

        } else if (3 == index) {
            navigate('/about');

        } else if (4 == index) {
            navigate('/recruit');

        } else if (5 == index) {
            navigate('/contact');

        }
    }

    return (
        <Stack
            onClick={itemClick}
            onMouseOver={() => { props.showWorks && props.showWorks() }}
            onMouseLeave={() => { props.hideWorks && props.hideWorks() }}
            sx={{
                cursor: 'pointer',
                height: '80px',
                position: 'relative',
                alignItems: 'center',
                justifyContent: 'center',
                mx: 3.5,
            }}>

            {/* 标题 */}
            <Typography sx={{
                height: 1,
                lineHeight: '80px',
                textAlign: 'center',
                color: settingData.navIndex == props.index ? '#FFA129' : 'white',
                fontSize: 20,
                fontFamily: settingData.fontFM,
                transitionDuration: '0.3s',
                '&:hover': {
                    color: '#FFA129',
                    transform: 'scale(1.1)',
                }
            }}>
                {props.title}
            </Typography>

            {/* 竖线 */}
            <Box
                id={props.navId && props.navId + props.index + '_line'}
                sx={{
                    width: '1.5px',
                    bgcolor: 'white',
                    position: 'absolute',
                    top: '60px',
                }} />
        </Stack>
    );
}

//导航下拉
function NavContentView(props) {

    return (
        <Stack
            id={props.navId && props.navId + '1_content'}
            sx={{
                height: 0,
                overflow: 'hidden',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                flexDirection: 'row',
                width: 1,
            }}>

            <Box sx={{
                position: 'absolute',
                height: '1px',
                bgcolor: 'white',
                width: 1,
                top: 0,
            }} />

            <ContentItem navId={props.navId} index={0} title='ONE PUNCH MAN: WORLD' imgName='logo_yq.png' />
            <ContentItem navId={props.navId} index={1} title='Street Fighter: Duel' imgName='logo_jb.png' showSFDUrl={props.showSFDUrl} hideSFDUrl={props.hideSFDUrl} />
            <ContentItem navId={props.navId} index={2} title='My Hero Academia:
The Strongest Hero' imgName='logo_yx.png' />
            <ContentItem navId={props.navId} index={3} title='Lord of Nazarick' imgName='overlord_icon.png' />
        </Stack>
    )
}

function ContentItem(props) {

    function itemTap() {
        if (props.index == 0) {
            window.open('https://eu.onepunchmanworld.com');

        } else if (props.index == 1) {
            // window.open('https://www.sfduelmobile.com');

        } else if (props.index == 2) {
            window.open('https://myherotsh.com/');

        }else if (props.index == 3) {
            window.open('https://lon.aplus-games.com/');

        }
    }

    return (
        <Stack
            onClick={itemTap}
            onMouseOver={() => { props.showSFDUrl && props.showSFDUrl() }}
            onMouseLeave={() => { props.hideSFDUrl && props.hideSFDUrl() }}
            sx={{
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                width: 0.3333,
                cursor: 'pointer',
            }}>
            <Box component={'img'}
                src={getImgPath(props.imgName)}
                sx={{
                    height: '55px',
                    my: 2,
                    transitionDuration: '0.3s',
                    '&:hover': {
                        transform: 'scale(1.1)',
                    }
                }} />

            <Typography sx={{
                fontFamily: 'Source Han Sans CN',
                fontSize: 12,
                ml: 1,
                whiteSpace: 'pre-line',
            }}>
                {props.title}
            </Typography>

            <Box
                component={'img'}
                src={getImgPath('arrow_right_black.png')}
                sx={{
                    display: props.index == 1 ? 'none' : 'flex',
                    height: '8px',
                    width: '8px',
                    borderRadius: '8px',
                    p: '4px',
                    objectFit: 'contain',
                    bgcolor: 'white',
                    ml: 2
                }} />
        </Stack>


    );
}

//语言
function LanguageView(props) {

    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);
    const [show, setShow] = React.useState(false);
    const [l1, setL1] = React.useState('jp');
    const [l2, setL2] = React.useState('cn');

    React.useEffect(() => {
        setTimeout(() => {
            refresh();
        }, 100);
    }, []);

    function onMouseOver() {
        setShow(true);
    }

    function onMouseLeave() {
        setShow(false);
    }

    function getName(l) {
        if ('cn' == l) {
            return '中文';
        } else if ('jp' == l) {
            return '日本語';
        } else {
            return 'English';
        }
    }

    function refresh() {
        if (settingObj.lang == 'cn') {
            setL1('en');
            setL2('jp');

        } else if (settingObj.lang == 'jp') {
            setL1('cn');
            setL2('en');

        } else {
            setL1('jp');
            setL2('cn');
        }
    }

    function tap(l) {
        dispatch(settingActions.setLanguage(l));
        refresh();
    }

    return (
        <Stack
            onMouseOver={onMouseOver}
            onMouseLeave={onMouseLeave}
            sx={{
                mr: 5,
                mt: 2,
                position: 'relative',
                height: '44px',
                width: '150px',
                minWidth: '150px',
                bgcolor: show ? '#FFA129' : 'white',
                borderRadius: '22px',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
                cursor: 'pointer',
            }}>
            <Box component={'img'}
                src={getImgPath('black_sanjiao.png')}
                sx={{
                    height: '12px',
                    mr: 1,
                }} />

            <Typography sx={{
                fontFamily: 'Source Han Sans CN',
                fontSize: 16,
            }}>
                {getName(settingData.lang)}
            </Typography>

            {/* 下拉菜单 */}
            <Stack sx={{
                display: show ? 'flex' : 'none',
                width: 1,
                height: '120px',
                position: 'absolute',
                mt: '150px',
            }}>
                <Stack sx={{
                    width: 1,
                    height: '100px',
                    bgcolor: 'white',
                    mt: '15px',
                    borderRadius: '22px',
                    overflow: 'hidden',
                }}>

                    <Typography
                        onClick={() => {
                            tap(l1);
                        }}
                        sx={{
                            fontFamily: 'Source Han Sans CN',
                            height: '50px',
                            lineHeight: '50px',
                            textAlign: 'center',
                            fontSize: 16,
                            transitionDuration: '0.3s',
                            '&:hover': {
                                bgcolor: '#DCDCDC',
                                transform: 'scale(1.1)',
                            }
                        }}>
                        {getName(l1)}
                    </Typography>

                    <Typography
                        onClick={() => {
                            tap(l2);
                        }}
                        sx={{
                            fontFamily: 'Source Han Sans CN',
                            height: '50px',
                            lineHeight: '50px',
                            textAlign: 'center',
                            fontSize: 16,
                            transitionDuration: '0.3s',
                            '&:hover': {
                                bgcolor: '#DCDCDC',
                                transform: 'scale(1.1)',
                            }
                        }}>
                        {getName(l2)}
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    );

}


function NavContentUrl(props) {

    return (
        <Stack
            id={props.navId && props.navId + 'url_content'}
            onMouseOver={() => { props.showSFDUrl && props.showSFDUrl() }}
            onMouseLeave={() => { props.hideSFDUrl && props.hideSFDUrl() }}
            sx={{
                width: '650px',
                position: 'relative',
                overflow: 'hidden',
                height: 0,
                alignItems: 'center',
            }}>
            {/* 横线 */}
            <Box
                sx={{
                    width: 0.1,
                    bgcolor: 'white',
                    height: '1px'
                }} />

            {/* 竖线 */}
            <Box
                sx={{
                    width: '1px',
                    bgcolor: 'white',
                    height: '20px'
                }} />

            {/* 横线 */}
            <Box
                sx={{
                    width: 0.48,
                    bgcolor: 'white',
                    height: '1px'
                }} />

            <Stack sx={{
                flexDirection: 'row',
                alignItems: 'center',
            }}>
                <UrlItem title='EU&MENA' url='https://www.sfduelmobile.com' />
                <UrlItem title='JAPAN' url='https://jp.sfduelmobile.com' />
                <UrlItem title='KOREA' url='https://kr.sfduelmobile.com' />
                <UrlItem title='SEA' url='https://sea.sfduelmobile.com' />
            </Stack>

        </Stack>
    );
}

function UrlItem(props) {

    function tap() {
        window.open(props.url);
    }

    return (
        <Stack
            onClick={tap}
            sx={{
                flexDirection: 'row',
                mx: 1.5,
                pt: 1,
                pb: 2,
                cursor: 'pointer',
                alignItems: 'center',
            }}>
            <Typography sx={{
                color: 'white',
                fontSize: 15,
                fontFamily: 'Lexend Deca',
            }}>
                {props.title}
            </Typography>

            <Box
                component={'img'}
                src={getImgPath('arrow_right_black.png')}
                sx={{
                    height: '8px',
                    width: '8px',
                    borderRadius: '8px',
                    p: '4px',
                    objectFit: 'contain',
                    bgcolor: 'white',
                    ml: '5px'
                }} />

        </Stack>
    );
}